<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'PrivacyAuditForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  props: {
    privacyAudit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onStartDateInput(newDate) {
      this.privacyAudit.startDate = newDate;
    },
    onEndDateInput(newDate) {
      this.privacyAudit.endDate = newDate;
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <v-flex md4>
          <v-text-field
            v-model="privacyAudit.name"
            label="Bezeichnung"
            height="22"
            class="caption"
            :disabled="privacyAudit.isFinished"
          />
        </v-flex>

        <v-flex md4>
          <v-text-field
            v-model="privacyAudit.auditor"
            label="Auditor"
            height="22"
            class="caption"
            :disabled="privacyAudit.isFinished"
          />
        </v-flex>

        <v-flex md4>
          <v-text-field
            v-model="privacyAudit.participants"
            label="Beteiligte"
            height="22"
            class="caption"
            :disabled="privacyAudit.isFinished"
          />
        </v-flex>

        <v-flex md4>
          <rbx-date-picker
            label="Beginn"
            :value="privacyAudit.startDate"
            @input="onStartDateInput"
          />
        </v-flex>

        <v-flex md4>
          <rbx-date-picker label="Ende" :value="privacyAudit.endDate" @input="onEndDateInput" />
        </v-flex>

        <v-flex md4>
          <rbx-remote-combobox-multiple
            v-model="privacyAudit.categories"
            :selected="privacyAudit.categories"
            searchable
            domain="Category"
            label="Relevante Kategorien"
            :disabled="privacyAudit.isFinished" />
        </v-flex>

        <v-flex md8>
          <v-textarea
            v-model="privacyAudit.text"
            label="Text"
            class="caption"
            :disabled="privacyAudit.isFinished"
          />
        </v-flex>

        <v-flex md4/>

        <v-flex md4>
          <rbx-remote-combobox
            v-model="privacyAudit.conclusion"
            :selected="privacyAudit.conclusion"
            searchable
            domain="AuditConclusion"
            label="Fazit"
            :disabled="!privacyAudit.isFinished"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
